import { useCallback, useRef, useState } from 'react'
import UploadIcon from '@nv/images/design/upload-icon'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import styles from './FileUploader.module.scss'

const allowedFilesDefault = ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx', 'mp3', 'mp4', 'mov', 'wav']
const allowedFilesTechFormatDefault = ['.png', '.jpg', '.jpeg', '.pdf', '.doc', '.docx', '.mp3', '.mp4', '.mov', '.wav']

// TODO: pass props for allowed file types and file size
const FileUploader = ({
  setUploadErr,
  onCallback,
  maxFileSize = 25,
  allowedFiles = allowedFilesDefault,
  allowedFilesTechFormat = allowedFilesTechFormatDefault,
}: any) => {
  const uploadRef = useRef(null)
  const { t } = useTranslation()
  const [isDragging, setIsDragging] = useState(false)
  const location = useLocation()
  const pathname = location.pathname

  if (pathname === '/admin/sftp') {
    allowedFiles = ['*']
    allowedFilesTechFormat = '*'
    maxFileSize = 500
  }

  const getFileType = (filename) => filename.split('.').pop().toLowerCase()

  const onImageClick = useCallback(() => {
    uploadRef.current.click()
  }, [])

  const onFileUpload = async (e) => {
    try {
      e.preventDefault()
      setIsDragging(false)

      const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0]

      if (!file) return

      if (file.size / 1024 / 1024 >= maxFileSize) {
        setUploadErr(t('uploads.errors.fileSize', { maxFileSize: maxFileSize.toString() }))
        return
      }

      if (allowedFilesTechFormat !== '*' && !allowedFiles.includes(getFileType(file.name))) {
        setUploadErr(t('uploads.errors.fileType'))
        return
      }

      onCallback({ redirect: 'Add Document', data: { name: file.name, file } })
    } catch (error) {
      setUploadErr(t('errors.contactSupport'))
    }
  }

  return (
    <>
      <div
        className={`${styles['container']} ${isDragging ? styles['drag-over'] : ''}`}
        onClick={onImageClick}
        onDragOver={(e) => {
          e.preventDefault()
          setIsDragging(true)
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onImageClick()
        }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={onFileUpload}
        role='button'
        tabIndex={0}
      >
        <UploadIcon />
        <h4 className={styles['text']}>{t('uploads.file.uploader')}</h4>
        <span className={styles['subtext']}>
          {t('uploads.file.addOne', { maxFileSize: maxFileSize.toString(), fileTypes: allowedFiles.join(', ') })}
        </span>
      </div>

      {allowedFilesTechFormat === '*' ? (
        <input type='file' onChange={onFileUpload} ref={uploadRef} style={{ display: 'none' }} />
      ) : (
        <input type='file' accept={allowedFilesTechFormat.toString()} onChange={onFileUpload} ref={uploadRef} style={{ display: 'none' }} />
      )}
    </>
  )
}

export default FileUploader
